import setJourneyStage from 'Data/actionCreators/journey/setJourneyStage';
import setNavMode from 'Data/actionCreators/setNavMode';
import setSearchLocation from 'Data/actionCreators/journey/setSearchLocation';
import {ACTION_TYPES, NAV_MODES} from 'Utils/constants';

const navigateBack = () => (dispatch, getState) => {
    const {navigationHistory} = getState().pageState.explorerMap;

    if (navigationHistory.length > 0) {
        if (navigationHistory[navigationHistory.length - 1].key === 'directions') {
            setNavMode(NAV_MODES.SEARCH)(dispatch, getState);
            setJourneyStage(null)(dispatch, getState);
        }

        // remove the last navigation history
        dispatch({
            type: ACTION_TYPES.POP_NAVIGATION_HISTORY,
        });
        if (navigationHistory.length > 0) {
            const prevNav = navigationHistory[navigationHistory.length - 1];
            dispatch({
                type: ACTION_TYPES.NAVIGATE,
                data: prevNav,
            });
            if (prevNav.key === 'featureSummary') {
                setSearchLocation({feature: prevNav.options.item, fitBounds: true})(
                    dispatch,
                    getState
                );
            }
        }
    }
};

export default navigateBack;
